import { call, put, takeLatest } from 'redux-saga/effects'
import Api from 'portal-modules/services/api'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import createFormAction from 'portal-modules/common/redux/create-form-action'
import { addError } from 'portal-modules/common/redux/modules/errors'
import ERROR_MSGS from 'portal-modules/auth/constants/error-message'

// action types
const REQUEST_USER_SERVICES = 'rp/services/REQUEST_USER_SERVICES'
const RECEIVE_USER_SERVICES = 'rp/services/RECEIVE_USER_SERVICES'

const CANCEL_REQUEST = 'rp/services/CANCEL_REQUEST'
const CANCEL_REQUEST_SUCCESS = 'rp/services/CANCEL_REQUEST_SUCCESS'

const REQUEST_SERVICE = 'rp/services/REQUEST_SERVICE'
const ADD_REQUESTED_SERVICE = 'rp/services/ADD_REQUESTED_SERVICE'

// reducer
export default (state = {}, { type, payload }) => {
  switch (type) {
    case RECEIVE_USER_SERVICES:
      return {
        ...state,
        ...payload,
      }
    case ADD_REQUESTED_SERVICE:
      return {
        ...state,
        [payload.id]: { ...payload },
      }

    case CANCEL_REQUEST_SUCCESS:
      delete state[payload.id]
      return { ...state }
    default:
      return state
  }
}

// action creators
export const requestUserServices = () => ({ type: REQUEST_USER_SERVICES })
export const cancelRequest = payload => ({ type: CANCEL_REQUEST, payload })
export const requestService = createFormAction(REQUEST_SERVICE)

// sagas
function* fetchUserServices() {
  const userServices = yield call(Api.getUserServices)
  if (userServices && userServices.length) {
    yield put({
      type: RECEIVE_USER_SERVICES,
      payload: userServices.reduce(
        (obj, service) => ({
          ...obj,
          [service.id]: service,
        }),
        {},
      ),
    })
  }
}

function* workerCancelRequest({ payload }) {
  yield call(Api.cancelServiceRequest, payload)
  // const result = yield call(Api.cancelServiceRequest, payload)
  yield put({
    type: CANCEL_REQUEST_SUCCESS,
    payload,
  })
}

function* watchUserRequestedServices() {
  yield takeLatest(
    REQUEST_USER_SERVICES,
    createRequestSaga(fetchUserServices, {
      key: 'userServices',
      message: __('Looking up your requested services'),
    }),
  )
}

function* watchCancelRequest() {
  yield takeLatest(
    CANCEL_REQUEST,
    createRequestSaga(workerCancelRequest, {
      key: 'services',
      message: __('Cancelling the service request'),
      write: true,
    }),
  )
}

function* workerRequestService({
  payload: { id, phone_number, email_address, unit_number },
}) {
  const requestedService = yield call(Api.requestService, {
    company_concierge_service_id: id,
    email_address,
    phone_number,
    unit_number,
  })

  if (requestedService) {
    yield put({
      type: ADD_REQUESTED_SERVICE,
      payload: requestedService.service_request,
    })
  }
}

function* watchRequestService() {
  yield takeLatest(
    REQUEST_SERVICE,
    createRequestSaga(workerRequestService, {
      key: 'services',
      message: __('Requesting your service'),
      successMessage: __('Service successfully requested'),
      onError: function* handleAddOrUpdateContactError({ code }, { key }) {
        switch (code) {
          case 1002:
            yield put(
              addError({ key, message: __('Error validating phone numbe') }),
            )
            break
          default:
            yield put(
              addError({
                key,
                message: ERROR_MSGS[code] || __('Something went wrong.'),
              }),
            )
            break
        }
      },
      write: true,
    }),
  )
}
export const sagas = [
  watchUserRequestedServices,
  watchCancelRequest,
  watchRequestService,
]
